"use client";
import React, { ReactElement, ReactNode, useEffect, useRef, useLayoutEffect } from "react";

import styles from "./index.module.css";
function Collapse({ children, open }: { children: ReactNode; open: boolean }) {
  const ref = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  
  // 使用useLayoutEffect确保DOM更新后再计算高度
  useLayoutEffect(() => {
    updateSize();
  }, [open, children]);
  
  // 添加ResizeObserver来监听内容变化
  useEffect(() => {
    if (!contentRef.current) return;
    
    const resizeObserver = new ResizeObserver(() => {
      if (open) {
        updateSize();
      }
    });
    
    resizeObserver.observe(contentRef.current);
    
    return () => {
      resizeObserver.disconnect();
    };
  }, [open]);
  
  const updateSize = () => {
    if (ref.current && contentRef.current) {
      // 使用requestAnimationFrame确保DOM完全渲染
      requestAnimationFrame(() => {
        if (ref.current && contentRef.current) {
          const height = open ? contentRef.current.scrollHeight : 0;
          ref.current.style.setProperty("height", `${height}px`);
        }
      });
    }
  };
  
  return (
    <>
      <div ref={ref} className={`${styles.collapse} ${open ? styles.show : styles.hidden}`}>
        <div ref={contentRef} className="">
          {children}
        </div>
      </div>
    </>
  );
}
export default Collapse;
